<template>
  <section>
    <land-section id="activity_items" space="20">
      <v-container style="max-width: 1200px;">
        <v-row justify="center">
          <v-col cols="12">
            <template>
              <div class="ql-editor" v-html="data.content" />
            </template>
          </v-col>
        </v-row>
      </v-container>
    </land-section>
    <!-- <section-foot /> -->
  </section>
</template>

<script>
import mixActivityDetail from "@/pages/mixins/activity/mix.exhibit.detail";
import axios from "axios";
import user from "@/api/co.user";
import apiUrl from "@/api/api/co.api.url";
export default {
  components: {
    ChosenWorks: () =>
      import("@/pages/sections/activity/ChosenWorksUpload.vue"),
    AllWorks: () => import("@/pages/sections/activity/AllWorks.vue"),
    DialogUploadTypes: () =>
      import("@/pages/sections/comm/DialogUploadTypes.vue"),
    DialogAlert: () => import("@/pages/sections/comm/DialogAlert.vue")
  },
  mixins: [mixActivityDetail],
  data() {
    return { id: "", currUser: {}, token: "",data:{} };
  },
  created() {
    this.id = this.$route.query.id;
    this.currUser = user.info.get();
    const obj = user.token.get();
    this.token = obj.token;
  },
  mounted() {
    this.getAlbum(this.id);
  },
  methods: {
    getAlbum(albumId) {
      axios
        .get(`${apiUrl.base_url}/api/getRoadShow/${albumId}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
            uuid: this.currUser.userId
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data=res.data.data;
          }
        });
    }
  }
};
</script>
<style>
.ql-editor img{
  width: 100%;
}
</style>
